






































import { Component, Vue, Watch } from 'vue-property-decorator';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import machineriesRepository from '@/modules/machinery/services/machineriesRepository';
import machineryProfilesRepository from '@/modules/machinery/services/machineryProfilesRepository';
import cPopup from '@/components/default/Popup.vue';
import cCard from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import MachineryCreatePopup from '@/modules/machinery/components/MachineryCreatePopup.vue';
import MachineryRentalsTable from '@/modules/machinery/components/MachineryRentalsTable.vue';
import { DxNavBar } from 'devextreme-vue';
import machineryEventsTable from '@/modules/machinery/components/machineryEventsTable.vue';
import machineryStatusRepository from '@/modules/machinery/services/machineryStatusRepository';

import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

@Component({
  components: {
    cCard,
    Datagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    MachineryCreatePopup,
    MachineryRentalsTable,
    DxNavBar,
    machineryEventsTable,
  },
})
export default class MachineryOverviewPage extends Vue {
  private items: any[] = [];
  private profiles: IMachineryProfileListItem[] = [];
  private loading: boolean = false;
  private saving: boolean = false;
  private displayAddProfileDialog: boolean = false;
  private addProfileDtu: any = { name: '' };
  private navIndex: number = 0;
  private selectedProfileId: string = '';
  private machineryStatus: IMachineryStatus[] = [];
  private onlyAvailable: boolean = false;
  private initialised: boolean = false;

  private mounted() {
    this.loadStatus();
    this.loadProfilesAsync();

    const machineryShowOnlyAvailable = localStorage.getItem('MachineryShowOnlyAvailable');
    if (machineryShowOnlyAvailable && machineryShowOnlyAvailable.toLowerCase() === 'true') {
      this.onlyAvailable = true;
    }

    this.initialised = true;
  }

  private refreshTable() {
    (this.$refs.grid as any).$refs.machineParkTable.instance.refresh();
  }

  private async loadStatus() {
    try {
      this.machineryStatus = (await machineryStatusRepository.getAll()).data;
    } catch (err) {
      // Do nothing
    }
  }

  private add() {
    (this.$refs.MachineryCreatePopup as MachineryCreatePopup).show();
  }

  private async loadProfilesAsync() {
    this.profiles = (await machineryProfilesRepository.getAll()).data;
  }

  private selectRow(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
      this.$router.push({ path: `/machinery/${e.data.id}` });
    }
  }

  private deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        self.saving = true;
        await machineriesRepository.delete(e.data.id);
        notificationService.saved();
        resolve(false);
      } catch {
        notificationService.failedToSave();
      } finally {
        self.saving = false;
      }
      resolve(true);
    });
  }

  get toolbarOptions() {
    const self = this;

    return [
      {
        location: 'center',
        widget: 'dxLookup',
        options: {
          dataSource: new DataSource({
            store: new dxCustomStore({
              load: async (loadOptions) => {
                return {
                    data: this.profiles ? this.profiles : [],
                };
              },
              byKey: (val: any) => {
                const result = this.profiles.find((o) => o.id === val);
                return result ? result : val;
              },
            }),
            paginate: true,
          }),
          displayExpr: 'name',
          valueExpr: 'id',
          searchEnabled: true,
          showClearButton: true,
          width: 300,
          onValueChanged: (e: any) => {
            if (e && e.value) {
              self.selectedProfileId = e.value;
              return;
            }
            self.selectedProfileId = '';
          },
          placeholder: 'Filter op profiel',
        },
      },
      {
        location: 'before',
        widget: 'dxCheckBox',
        options: {
          text: 'Direct beschikbaar',
          width: 300,
          value: self.onlyAvailable,
          onValueChanged: (e: any) => {
            if (e) {
              self.onlyAvailable = e.value;
              localStorage.setItem('MachineryShowOnlyAvailable', e.value);
              self.refreshTable();
              return;
            }
          },
        },
      },
    ];
  }

  get columns() {
    return [
      {
        dataField: 'licensePlate',
        caption: this.$t('objects.machinery.fields.LicensePlate'),
      },
      {
        dataField: 'statusId',
        caption: 'Status',
        lookup: {
          dataSource: this.machineryStatus,
          valueExpr: 'id',
          displayExpr: 'name',
        },
      },
      {
        dataField: 'location',
        caption: 'Locatie',
      },
      {
        dataField: 'internalNumber',
        caption: 'Internnr.',
      },
      {
        dataField: 'brand',
        caption: 'Merk',
      },
      {
        dataField: 'type',
        caption: 'Soort',
      },
      {
        dataField: 'purchaseDate',
        caption: 'Aankoopdatum',
        dataType: 'date',
      },
      {
        dataField: 'serialNumber',
        caption: 'Serienr.',
      },
      {
        dataField: 'purchaseValue',
        caption: 'Aankoopwaarde',
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'residualValue',
        caption: 'Restwaarde',
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'listPrice',
        caption: 'Catalogusprijs',
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'color',
        caption: 'Kleur',
      },
      {
        dataField: 'constructionYear',
        caption: 'Bouwjaar',
        dataType: 'number',
        alignment: 'left',
      },
      {
        type: 'buttons',
        buttons: ['delete'],
      },
    ];
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-snowplow', text: 'Machinepark'},
      { icon: 'fas fa-bell', text: 'Events'},
      { icon: 'fas fa-calendar-alt', text: 'Verhuur'},
    ];
  }

  get datasource() {
    const self = this;
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          /*data: result.data.data,
            totalCount: result.data.totalCount,*/
          const result = await machineriesRepository.lookup(loadOptions, this.selectedProfileId, this.onlyAvailable);
          return result.data;
        },
      }),
      paginate: true,
    });
  }

  @Watch('selectedProfileId')
  private onContactChange() {
    this.refreshTable();
  }
}
